// extracted by mini-css-extract-plugin
export default {"inputLabel":"SearchField_inputLabel__uv1Cj","icon":"SearchField_icon__Pwx8J"};